import { Component, OnInit } from '@angular/core';
import {
  SpecialWagerIndex,
  SpecialWagerType,
  SpecialWagerTypeCrudService,
  CreateSpecialWagerTypeCommand,
  UpdateSpecialWagerTypeCommand,
  TracksService, PublicTrack
} from "@swagger-codegen/*";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {Router} from '@angular/router';
import {BlockUI, NgBlockUI} from "ng-block-ui";
import {finalize, takeUntil} from "rxjs/operators";
import * as _ from "lodash";
import {Observable} from "rxjs";
import {TakeUntilDestroy} from "@services/take-until-destroy.decorator";

@TakeUntilDestroy
@Component({
  selector: 'app-special-wagers',
  templateUrl: './special-wagers.component.html',
  styleUrls: ['./special-wagers.component.scss']
})
export class SpecialWagersComponent implements OnInit {
  componentDestroy: () => Observable<boolean>;
  @BlockUI()
  blockUI: NgBlockUI;
  public specialWagerType: SpecialWagerIndex;
  public uniqueSpecialWagerTypes: SpecialWagerType[] = [];
  public currentWager: SpecialWagerType | null = null;
  public isEditMode = false;
  public originalTracks: PublicTrack[];
  public tracks: PublicTrack[];
  public tracksSorted: PublicTrack[];

  constructor(
    private swt: SpecialWagerTypeCrudService,
    private modalService: NgbModal,
    private router: Router,
    private trackService: TracksService
  ) { }

  ngOnInit(): void {
    this.blockUI.start();
    this.loadWagerTypes();
    this.trackService.apiAdminTracksGet()
      .pipe(
        finalize(() => {
          this.blockUI.stop();
        }),
        takeUntil(this.componentDestroy()))
      .subscribe((result) => {
        var specialTracks = result.filter(track => track.equibaseCountry === 'USA' &&
          (
            this.uniqueSpecialWagerTypes.map(wt => wt.trackId).includes(track.id) &&
            (track.abbreviation.indexOf('EQ') === 0 || track.abbreviation.indexOf('SW') === 0 || track.abbreviation.indexOf('BC') === 0)
          )
        );

        this.originalTracks =
          specialTracks.concat(
            _.chain(result.filter(track => track.equibaseCountry === 'USA' && (track.abbreviation.indexOf('EQ') === -1 && track.abbreviation.indexOf('SW') === -1 && track.abbreviation.indexOf('BC') === -1
            ))).orderBy(
              ['needsAttention', 'name'],
              ['desc', 'asc']
            ).value());
        console.log("Original Tracks:", this.originalTracks);
      });
  }

  loadWagerTypes(): void {
    this.swt.apiAdminVversionSpecialWagerTypeCrudGet("1.0").subscribe(response => {
      this.specialWagerType = response;
      this.uniqueSpecialWagerTypes = Array.from(
        new Map(response.specialWagerTypes.map(item => [item.trackId, item])).values()
      );
    });
  }

  openAddModal(content): void {
    this.isEditMode = false;
    this.currentWager = {} as SpecialWagerType;
    this.modalService.open(content, { centered: true });
  }

  editWager(wager: SpecialWagerType, content): void {
    this.isEditMode = true;
    this.currentWager = { ...wager };
    this.modalService.open(content, { centered: true });
  }

  deleteWager(wager: SpecialWagerType): void {
    if (confirm(`Are you sure you want to delete ${wager.name}?`)) {
      this.swt.apiAdminVversionSpecialWagerTypeCrudIdDelete(wager.id, "1.0")
        .subscribe(() => {
          console.log(`Deleted wager: ${wager.name}`);
          this.loadWagerTypes();
        });
    }
  }

  unDeleteWager(wager: SpecialWagerType): void {
    if (confirm(`Are you sure you want to undelete ${wager.name}?`)) {
      this.swt.apiAdminVversionSpecialWagerTypeCrudIdPut(wager.id, "1.0", { ...wager, isDeleted: false } as UpdateSpecialWagerTypeCommand)
        .subscribe(() => {
          this.loadWagerTypes();
        });
    }
  }

  async goToRaces(wagerId: number): Promise<void> {
    console.log('navigating to', wagerId);
    await this.router.navigate([`/special-wager-races/${wagerId}`])
  }

  saveWager(modal): void {
    if (this.isEditMode) {
      // Update existing wager
      const updateCommand: UpdateSpecialWagerTypeCommand = {
        name: this.currentWager.name,
        trackId: this.currentWager.trackId,
        trackAbbreviation: this.currentWager.trackAbbreviation,
        customTrackAbbreviation: this.currentWager.customTrackAbbreviation,
        trackName: this.currentWager.trackName,
        slotCount: this.currentWager.slotCount,
        id: this.currentWager.id,
      };

      console.log("Update Command:", updateCommand);
      console.log("Update Command:", this.currentWager);


      this.swt.apiAdminVversionSpecialWagerTypeCrudIdPut(this.currentWager.id, "1.0", updateCommand)
        .subscribe(() => {
          this.loadWagerTypes();
          modal.close();
        });
    } else {
      // Create new wager
      const createCommand: CreateSpecialWagerTypeCommand = {
        name: this.currentWager.name,
        trackId: this.currentWager.trackId,
        trackAbbreviation: this.currentWager.trackAbbreviation,
        customTrackAbbreviation: this.currentWager.customTrackAbbreviation,
        trackName: this.currentWager.trackName,
        slotCount: this.currentWager.slotCount
      };

      this.swt.apiAdminVversionSpecialWagerTypeCrudPost("1.0", createCommand)
        .subscribe(() => {
          this.loadWagerTypes();
          modal.close();
        });
    }
  }
}
